import React from 'react'
import { Link } from 'react-router-dom'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// components
import SectionSubheader from 'components/atoms/SectionSubheader'
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const Section = props => {
  const { title, subheaderText, buttonText, buttonRoute, children } = props

  return (
    <Box mt={[2, 4, 6]} mb={[4, 6, 8]}>
      {title && (
        <Typography variant='h2' align='center' sx={{ mb: 4 }}>
          {title}
        </Typography>
      )}
      <Box my={4}>
        {subheaderText && <SectionSubheader>{subheaderText}</SectionSubheader>}
        {children}
      </Box>
      {buttonText && (
        <ResponsiveButton align='left' to={buttonRoute}>
          {buttonText}
        </ResponsiveButton>
      )}
    </Box>
  )
}

export default Section
